import BOOTSTRAP_OPTIONS from '../constants/feature.flags'
import context from './context'
import { DEFAULT_FEATURES } from './default-features'
import TDFeatures from 'td-features-js'

const tdFeatures = new TDFeatures()

export const initTDFeatures = async () => {
  tdFeatures.options = {
    ...tdFeatures.options,
    accountId: context.tenantId,
    key: context.splitIoKeyUI,
    defaults: DEFAULT_FEATURES
  }
  await tdFeatures.bootstrap(BOOTSTRAP_OPTIONS)
}

export const isAutomationAccount = () => {
  return tdFeatures.isActive('AUTHN_automation_account')
}
